import { View } from "react-native"

import { Text } from "./core"
import { cn } from "@src/utils"
import { ar } from "@src/i18n/ar"

type NotificationBadgeProps = {
  reachable?: boolean
  optedIn?: boolean
  className?: string
}

/**
 * Reachability indicator derived from a customer's device summary.
 *  - Green (opted in):      a device with a token and granted status.
 *  - Amber (not opted in):  a token exists but none is granted (denied or null).
 *  - Gray (not reachable):  no token-bearing device.
 */
export function NotificationBadge({ reachable, optedIn, className }: NotificationBadgeProps) {
  const { dot, label, text } = optedIn
    ? { dot: "bg-green-500", label: ar.notificationReachable, text: "text-green-700" }
    : reachable
      ? { dot: "bg-amber-500", label: ar.notificationNotOptedIn, text: "text-amber-700" }
      : { dot: "bg-gray-400", label: ar.notificationNotReachable, text: "text-gray-500" }

  return (
    <View className={cn("flex-row items-center gap-1", className)}>
      <View className={cn("w-2 h-2 rounded-full", dot)} />
      <Text className={cn("text-xs", text)}>{label}</Text>
    </View>
  )
}
